var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-button"},[_c('PromoButton',{on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.$t("page.button"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }